





import {Component, Prop, Vue} from 'vue-property-decorator';

/**
 * @status stable
 * @published $next
 * @changelog $next Published.
 */
@Component
export default class JdhInlineInputArea extends Vue {
    @Prop({default: false, type: Boolean}) focus!: boolean

}
